<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalDeliveryVisible" :vm-is-valid="!$v.delivery.$invalid" vm-title='Edit Delivery Deadline')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(style="width: 100%" :label='$t("projects.date")' :danger="$v.delivery.delivery_deadline.$invalid && $v.delivery.delivery_deadline.$model" :danger-text="$t('validation.required', { attribute: $t('projects.delivery_deadline') })" v-model="delivery.delivery_deadline")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            vm-textarea(:placeholder='$t("projects.delivery_deadline_comments_placeholder")' :danger="$v.delivery.delivery_deadline_comments.$invalid && $v.delivery.delivery_deadline_comments.$model" :danger-text="$t('validation.required', { attribute: $t('projects.delivery_deadline_comments') })" v-model="delivery.delivery_deadline_comments" type="text" :label='$t("projects.delivery_deadline_comments")')
</template>
<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalDelivery',
  props: {
    delivery: {
      type: Object
    }
  },
  validations: {
    delivery: {
      delivery_deadline: {
        required
      },
      delivery_deadline_comments: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalDeliveryVisible'
    ])
  },
  methods: {
    ...mapActions([
      'setModalDeliveryVisible',
      'AddDelivery'
    ]),
    saveRecord () {
      this.AddDelivery(this.delivery)
    },
    close () {
      this.setModalDeliveryVisible(false)
    }
  }
}
</script>
